module.exports = __webpack_public_path__ + "static/media/SFProText-MediumItalic.597d7713.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-MediumItalic.ttf
// module id = 2551
// module chunks = 7